var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info"},[_c('a',{attrs:{"data-toggle":"collapse","aria-expanded":!_vm.isClosed,"href":"#"}},[_c('strong',[_vm._v("\n        "+_vm._s(_vm.name)+"\n      ")])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo text-white"},[_c('i',{staticClass:"fas fa-user fa-2x"})])
}]

export { render, staticRenderFns }